import React from 'react';
import styles from './Header.module.css';

export default function Header() {
    return (
        <div className={styles.header}>
            <div className={styles.pageWrap}>
                <a 
                    data_tealium_category="link"
					data_tealium_action="click"
					data_tealium_type="navigation"
					data_tealium_value= "BASF logo||https://agro.basf.ca"
                    href="https://agro.basf.ca"
                >
                    <img src={'/preseedherbicide/images/BASF_Logo.svg'} alt="BASF Logo" />
                </a>
            </div>         
        </div>        
    )
}